module.exports = __webpack_public_path__ + "img/7.4a932d13.png";